/** Do not edit this file, it is automatically generated **/
import React, { PropsWithChildren } from "react";
import styled from "styled-components";

import Icon, { IconProps } from "./Icon";

const IconUpArrowLineComponent: React.FC<PropsWithChildren<IconProps>> & { DataUrl: string; Content: string; } = (props) => {
return (
  <Icon {...props} viewBox="0 0 10 10">
    <g>
    <path d="M5.4 1.9l4.5 4.5c.1.1.2.2.2.4 0 .1-.1.3-.2.4l-.3.3c-.2.2-.6.2-.8 0L5 3.7l-3.7 3.7c-.1.1-.2.2-.4.2-.1 0-.3-.1-.4-.2l-.3-.3c-.1-.1-.2-.2-.2-.4 0-.1.1-.3.2-.4l4.5-4.5c.1-.1.2-.2.4-.2C5.1 1.7 5.3 1.8 5.4 1.9z" />
</g>
  </Icon>
);
};

IconUpArrowLineComponent.DataUrl = "data:image/svg+xml;charset=utf-8;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMTAgMTAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGc+CiAgICA8cGF0aCBkPSJNNS40IDEuOWw0LjUgNC41Yy4xLjEuMi4yLjIuNCAwIC4xLS4xLjMtLjIuNGwtLjMuM2MtLjIuMi0uNi4yLS44IDBMNSAzLjdsLTMuNyAzLjdjLS4xLjEtLjIuMi0uNC4yLS4xIDAtLjMtLjEtLjQtLjJsLS4zLS4zYy0uMS0uMS0uMi0uMi0uMi0uNCAwLS4xLjEtLjMuMi0uNGw0LjUtNC41Yy4xLS4xLjItLjIuNC0uMkM1LjEgMS43IDUuMyAxLjggNS40IDEuOXoiLz4KICA8L2c+Cjwvc3ZnPg==";
IconUpArrowLineComponent.Content = `<svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg">
  <g>
    <path d="M5.4 1.9l4.5 4.5c.1.1.2.2.2.4 0 .1-.1.3-.2.4l-.3.3c-.2.2-.6.2-.8 0L5 3.7l-3.7 3.7c-.1.1-.2.2-.4.2-.1 0-.3-.1-.4-.2l-.3-.3c-.1-.1-.2-.2-.2-.4 0-.1.1-.3.2-.4l4.5-4.5c.1-.1.2-.2.4-.2C5.1 1.7 5.3 1.8 5.4 1.9z"/>
  </g>
</svg>`;

const IconUpArrowLine = styled(IconUpArrowLineComponent)``;

export default IconUpArrowLine;
